import { contracts } from '../../data/contracts'

export default {
	id: 0,
	name: 'OLAND - ANKR',
	deposit: '0',
	pair: {
		token0: {
			name: 'OLAND',
			symbol: 'OLAND',
			address: contracts[process.env.REACT_APP_NETWORK].olandAddress,
			logo: 'tokens/Oland.png'
		},
		token1: {
			name: 'ANKR',
			symbol: 'ANKR',
			address: contracts[process.env.REACT_APP_NETWORK].ankrAddress,
			logo: 'tokens/Ankr2.png'
		},
		address: contracts[process.env.REACT_APP_NETWORK].DEX.Pairs.OLAND_ANKR
	}
}
